module.exports = __webpack_public_path__ + "img/img-1-mobile.b179e3b0.webp";